/* tslint:disable:max-line-length */
import * as React from 'react'

export const LOGO = {
  smallLogo: (
    <g>
      <path d="M179,205H87V36h92V205z M17.6,0C7.9,0,0,8.3,0,18.6c0,4.9,1.8,9.7,5.1,13.1c3.3,3.5,7.8,5.4,12.4,5.4h32.9V240h166V37.1h33c4.7,0,9.1-2,12.4-5.4c3.3-3.5,5.1-8.2,5.1-13.1s-1.8-9.7-5.1-13.1c-3.3-3.5-7.8-5.4-12.4-5.4L17.6,0L17.6,0z" />
    </g>
  ),

  bigLogo: (
    <g>
      <path
        d="M128,66.8h7.3c-0.3-1.8-1.8-3.1-3.6-3C129.8,63.7,128.5,65.1,128,66.8L128,66.8z M128,69.9
        c0.3,1.7,1.8,3.2,4.2,3.2c1.6,0,3.2-0.7,4.2-2l2.3,3c0,0-2.4,2.9-6.8,2.9c-4.7,0-8.4-3.9-8.4-8.6c0-4.7,3.7-8.5,8.3-8.6
        c4.5,0,7.9,3.5,7.9,8.2c0,0.6,0,1.2-0.2,1.8H128z M117,67.6c0-2.2-1.1-3.4-2.6-3.4c-1.6,0-2.9,1.3-2.9,3.9v8.6h-4.4v-9.1
        c0-2.2-1.1-3.4-2.6-3.4c-1.6,0-2.9,1.3-2.9,3.9v8.6h-4.4V60.2h4.4v2c0,0,1.5-2.4,4.2-2.4c3.4,0,4.5,2.9,4.5,2.9s1.8-2.9,5.4-2.9
        c3.4,0,5.7,2.4,5.7,7.2v9.6H117V67.6z M92.4,72c1.5,0,2.6,1.2,2.6,2.5S93.9,77,92.4,77c-1.5,0-2.6-1.2-2.6-2.5S90.9,72,92.4,72z
         M154.2,38.2c0,0-1-1.3-2.6-1.3c-1.3,0-1.9,0.7-1.9,1.3c0,2.4,7.3,1.2,7.3,6.7c0,2.9-2.3,5.2-6.3,5.2c-4.5,0-6.5-3-6.5-3l2.4-2.5
        c0,0,1.3,1.8,3.4,1.8c1.5,0,2.1-0.7,2.1-1.5c0-2.5-7.3-1.3-7.3-6.7c0-2.5,2.6-5.2,6.2-5.2c3.7,0,5.5,2.5,5.5,2.5L154.2,38.2z
         M143.6,37.7c-0.5-0.1-1-0.2-1.5-0.2c-2.3,0-3.7,1.5-3.7,4.4v7.9h-4.4V33.3h4.4v2c1.1-1.4,2.8-2.2,4.5-2.2h0.6L143.6,37.7z
         M119.7,41.6c0,2.7,1.8,4.5,3.9,4.5c2.1,0,3.9-1.8,3.9-4.5c0-2.7-1.8-4.5-3.9-4.5C121.5,37,119.7,38.9,119.7,41.6L119.7,41.6z
         M119.7,47.8v9.1h-4.4V33.3h4.4v2c1.1-1.5,2.9-2.3,4.7-2.4c4.1,0,7.6,3.7,7.6,8.6c0,4.9-3.6,8.6-7.6,8.6
        C122.6,50.1,120.8,49.3,119.7,47.8L119.7,47.8z M113.5,37.7c-0.5-0.1-1-0.2-1.5-0.2c-2.3,0-3.7,1.5-3.7,4.4v7.9h-4.4V33.3h4.4v2
        c1.1-1.4,2.8-2.2,4.5-2.2h0.6V37.7z M99.1,38.2c0,0-1-1.3-2.6-1.3c-1.3,0-1.9,0.7-1.9,1.3c0,2.4,7.3,1.2,7.3,6.7
        c0,2.9-2.3,5.2-6.3,5.2c-4.5,0-6.5-3-6.5-3l2.4-2.5c0,0,1.3,1.8,3.4,1.8c1.5,0,2.1-0.7,2.1-1.5c0-2.5-7.3-1.3-7.3-6.7
        c0-2.5,2.6-5.2,6.2-5.2c3.7,0,5.5,2.5,5.5,2.5L99.1,38.2z"
      />
      <path
        d="M60.4,65.1H28.5V11.9h31.9V65.1z M5.9,0C2.6,0,0,2.7,0,6c0,1.6,0.6,3.1,1.7,4.2s2.6,1.7,4.1,1.7h11V77h55.3
        V11.9h11c1.6,0,3-0.6,4.1-1.7C88.4,9.1,89,7.5,89,6c0-1.6-0.6-3.1-1.7-4.2C86.2,0.6,84.7,0,83.1,0H5.9z"
      />
    </g>
  ),

  logo: (
    <g>
      <path d="M344.3,418.6H167.8V94.4h176.5V418.6z M34.7,25.3C16.1,25.3,0.9,41.2,0.9,61c0,9.4,3.5,18.6,9.8,25.1c6.3,6.7,15,10.4,23.8,10.4h63.1v389.2h318.4V96.5h63.3c9,0,17.5-3.8,23.8-10.4c6.3-6.7,9.8-15.7,9.8-25.1s-3.5-18.6-9.8-25.1c-6.3-6.7-15-10.4-23.8-10.4H34.7V25.3z" />
    </g>
  ),

  symbol: (
    <g>
      <path d="M344.3,418.6H167.8V94.4h176.5V418.6z M34.7,25.3C16.1,25.3,0.9,41.2,0.9,61c0,9.4,3.5,18.6,9.8,25.1c6.3,6.7,15,10.4,23.8,10.4h63.1v389.2h318.4V96.5h63.3c9,0,17.5-3.8,23.8-10.4c6.3-6.7,9.8-15.7,9.8-25.1s-3.5-18.6-9.8-25.1c-6.3-6.7-15-10.4-23.8-10.4H34.7V25.3z" />
    </g>
  ),

  wordMark: (
    <path d="M293.7,344.9h54.9c-2.3-13.5-13.7-23.2-26.9-22.9C307.2,322.1,297.4,332.2,293.7,344.9L293.7,344.9z M293.7,369.1c2.4,12.7,13.4,24.1,31.8,24.1c12.2,0,23.9-5.5,31.8-15.2l17.1,22.9c0,0-18.3,21.6-51.3,21.6 c-35.4,0-63.5-29.2-63.5-64.8c0.1-35.7,27.9-64.6,62.3-64.8c34.2,0,59.8,26.7,59.8,62.3c0.1,4.7-0.3,9.4-1.2,14H293.7z M211,351.3 c0-16.5-8.6-25.4-19.5-25.4c-12.2,0-22,10.2-22,29.2v64.8h-33v-68.6c0-16.5-8.6-25.4-19.5-25.4c-12.2,0-22,10.2-22,29.2v64.8H62 V295.3h33v15.2c0,0,11-17.8,31.8-17.8c25.6,0,34.2,21.6,34.2,21.6s13.4-21.6,40.3-21.6c25.7,0,42.8,17.8,42.8,54.6v72.4h-33V351.3z M25.7,384.3c11,0,19.5,8.9,19.5,19c0,10.2-8.6,19-19.5,19s-19.5-8.9-19.5-19C6.1,393.2,14.7,384.3,25.7,384.3z M491.3,129 c0,0-7.3-10.2-19.6-10.2c-9.8,0-14.7,5.1-14.7,10.2c0,17.8,54.9,8.9,54.9,50.8c0,21.6-17.1,39.4-47.6,39.4 c-34.2,0-48.9-22.9-48.9-22.9l18.3-19c0,0,9.8,14,25.6,14c11,0,15.9-5.1,15.9-11.4c0-19-54.9-9.7-54.9-50.8 c0-19,19.5-39.4,46.4-39.4c28.1,0,41.5,19,41.5,19L491.3,129z M411.4,125.2c-3.6-1-7.3-1.4-11-1.3c-17.1,0-28.1,11.4-28.1,33v59.7 h-33V92.1h33v15.2c8.6-10.4,21-16.4,34.2-16.5h4.9L411.4,125.2z M231,154.4c0,20.3,13.4,34.3,29.3,34.3c15.9,0,29.3-14,29.3-34.3 s-13.4-34.3-29.3-34.3C244.4,120.1,231,134.1,231,154.4L231,154.4z M231,201.4v68.6h-33V92.1h33v15.2c8.6-11.2,21.6-17.7,35.4-17.8 c30.5,0,57.4,28,57.4,64.8c0,36.8-26.9,64.8-57.4,64.8C252.6,219.1,239.6,212.6,231,201.4L231,201.4z M184.1,125.2 c-3.6-1-7.3-1.4-11-1.3c-17.1,0-28.1,11.4-28.1,33v59.7h-33V92.1h33v15.2c8.6-10.4,21-16.4,34.2-16.5h4.9V125.2z M75.7,129 c0,0-7.3-10.2-19.5-10.2c-9.8,0-14.7,5.1-14.7,10.2c0,17.8,54.9,8.9,54.9,50.8c0,21.6-17.1,39.4-47.6,39.4 C14.7,219.2,0,196.3,0,196.3l18.3-19c0,0,9.8,14,25.6,14c11,0,15.9-5.1,15.9-11.4c0-19-54.9-9.7-54.9-50.8c0-19,19.5-39.4,46.4-39.4 c28.1,0,41.5,19,41.5,19L75.7,129z" />
  ),

  words: (
    <g>
      <path
        fill="#fff"
        d="M293.7,251.4h54.9c-2.3-13.3-13.7-22.9-26.9-22.5C307.2,228.9,297.4,238.9,293.7,251.4L293.7,251.4z M293.7,275.2
                        c2.4,12.5,13.4,23.8,31.8,23.8c12.2,0,23.9-5.4,31.8-15l17.1,22.5c0,0-18.3,21.2-51.3,21.2c-35.4,0-63.5-28.8-63.5-63.8
                        c0.1-35.2,27.9-63.7,62.3-63.8c34.2,0,59.8,26.3,59.8,61.3c0.1,4.6-0.3,9.2-1.2,13.7H293.7z M211,257.6c0-16.3-8.6-25-19.5-25
                        c-12.2,0-22,10-22,28.8v63.8h-33v-67.5c0-16.3-8.6-25-19.5-25c-12.2,0-22,10-22,28.8v63.8H62V202.6h33v15c0,0,11-17.5,31.8-17.5
                        c25.6,0,34.2,21.3,34.2,21.3s13.4-21.3,40.3-21.3c25.7,0,42.8,17.5,42.8,53.8v71.3h-33V257.6z M25.7,290.2c11,0,19.5,8.7,19.5,18.8
                        s-8.6,18.8-19.5,18.8c-11,0-19.5-8.7-19.5-18.8S14.7,290.2,25.7,290.2z M491.3,38.8c0,0-7.3-10-19.6-10c-9.8,0-14.7,5-14.7,10
                        c0,17.5,54.9,8.8,54.9,50c0,21.3-17.1,38.8-47.6,38.8c-34.2,0-48.9-22.5-48.9-22.5l18.3-18.8c0,0,9.8,13.8,25.6,13.8
                        c11,0,15.9-5,15.9-11.3c0-18.8-54.9-9.5-54.9-50C420.4,20.1,440,0,466.8,0c28.1,0,41.5,18.8,41.5,18.8L491.3,38.8z M411.4,35.1
                        c-3.6-1-7.3-1.4-11-1.3c-17.1,0-28.1,11.3-28.1,32.5v58.8h-33V2.5h33v15c8.6-10.2,21-16.2,34.2-16.3h4.9L411.4,35.1z M231,63.8
                        c0,20,13.4,33.8,29.3,33.8c15.9,0,29.3-13.8,29.3-33.8c0-20-13.4-33.8-29.3-33.8C244.4,30,231,43.8,231,63.8L231,63.8z M231,110
                        v67.5h-33V2.5h33v15c8.6-11,21.6-17.5,35.4-17.5c30.5,0,57.4,27.5,57.4,63.8s-26.9,63.8-57.4,63.8C252.6,127.5,239.6,121.1,231,110
                        L231,110z M184.1,35c-3.6-1-7.3-1.4-11-1.3C156,33.8,145,45,145,66.3v58.8h-33V2.5h33v15c8.6-10.2,21-16.2,34.2-16.3h4.9V35z
                        M75.7,38.8c0,0-7.3-10-19.5-10c-9.8,0-14.7,5-14.7,10c0,17.5,54.9,8.8,54.9,50c0,21.3-17.1,38.8-47.6,38.8
                        C14.7,127.6,0,105.1,0,105.1l18.3-18.8c0,0,9.8,13.8,25.6,13.8c11,0,15.9-5,15.9-11.3c0-18.8-54.9-9.5-54.9-50
                        C4.9,20,24.4,0,51.3,0c28.1,0,41.5,18.8,41.5,18.8L75.7,38.8z"
      />
    </g>
  ),

  aynim: (
    <g fill="#900712">
      <g>
        <path
          d="M131.1,18.3v87.9c0,11-5.2,17.8-16.1,17.8S99,117.2,99,106.2V52L66,93.5L33,52v70.2H0.8V3.8h28.8L66,50.3
                    l26.7-34.5C99.8,6.5,104.2,2.1,114,2.1C124.2,2.1,131.1,9,131.1,18.3z"
        />
        <path
          d="M214.4,125.6c-37.2,0-66-28.8-66-62.6c0-33.9,28.8-62.6,66-62.6c37.2,0,66,28.8,66,62.6
                    C280.4,96.9,251.7,125.6,214.4,125.6z M214.4,96.9c18.6,0,33-14.4,33-33.9s-14.4-33.9-33-33.9s-33,14.4-33,33.9
                    S195.8,96.9,214.4,96.9z"
        />
        <path
          d="M391.1,102.1c6.3,10,1,21.8-12.5,21.8c-5.2,0-9.5-1.7-13.2-8l-18.3-31h-17.3v37.2h-32.2V3.8h55.9
                    c25.4,0,43.2,17.8,43.2,40.6c0,15.1-7.4,27.6-20,34.5L391.1,102.1z M364.6,44.4c0-6.8-5.1-11.8-12.7-11.8h-22v23.7h22
                    C359.5,56.2,364.6,51.2,364.6,44.4z"
        />
        <path
          d="M512,108.9c0,8.6-6.3,13.4-15.4,13.4h-80.1V3.8h91.4v27.1h-59.2v18.6h45.7v25.4h-45.7v20.3h47.9
                    C505.7,95.2,512,99.9,512,108.9z"
        />
      </g>
      <path
        d="M233,48.6c-0.7-0.7-1.7-1.1-2.7-1.1h-31.9c-2.1,0-3.8,1.7-3.8,3.9c0,1,0.4,2,1.1,2.7c0.7,0.7,1.7,1.1,2.7,1.1
                h3.1V82h25.6V55.2h3.1c1,0,2-0.4,2.7-1.1c0.7-0.7,1.1-1.7,1.1-2.7C234.1,50.3,233.7,49.3,233,48.6z M209.2,74.2v-19h10.3v19H209.2z"
      />
    </g>
  ),

  inCircle: (
    <g>
      <path
        id="symbol"
        d="M160.8,168.9c-8.4,0-15.1,6.9-15.1,15.4c0,4.1,1.6,8,4.4,10.9c2.8,2.9,6.7,4.5,10.7,4.5h28.3v167.9
                h143.1V199.6h28.5c4,0,7.9-1.6,10.7-4.5c2.8-2.9,4.4-6.8,4.4-10.9c0-4.1-1.6-8-4.4-10.9c-2.8-2.9-6.7-4.5-10.7-4.5H160.8z
                M301.9,336.8h-82.6V199.6h82.6V336.8z"
      />
      <path
        d="M256.5,1C115.6,1,1,115.6,1,256.5C1,397.4,115.6,512,256.5,512C397.4,512,512,397.4,512,256.5
                C512,115.6,397.4,1,256.5,1z M261.2,451.1c-104.7,0-189.9-85.2-189.9-189.9c0-104.7,85.2-189.9,189.9-189.9
                c104.7,0,189.9,85.2,189.9,189.9C451.1,365.9,365.9,451.1,261.2,451.1z"
      />
    </g>
  ),

  cardEntryLogo: (
    <path
      fill="none"
      d="M 213.47,71.17
            C 213.47,71.17 150.79,71.17 150.79,71.17
            150.79,71.17 150.79,185.96 150.79,185.96
            150.79,185.96 213.47,185.96 213.47,185.96
            213.47,185.96 213.47,71.17 213.47,71.17 Z
            M 103.50,46.79
            C 103.50,46.79 261.44,46.79 261.44,46.79
            264.58,46.79 267.64,48.08 269.89,50.46
            272.14,52.77 273.37,56.03 273.37,59.36
            273.37,62.68 272.14,65.88 269.89,68.25
            267.64,70.56 264.64,71.92 261.44,71.92
            261.44,71.92 238.96,71.92 238.96,71.92
            238.96,71.92 238.96,209.73 238.96,209.73
            238.96,209.73 125.85,209.73 125.85,209.73
            125.85,209.73 125.85,71.92 125.85,71.92
            125.85,71.92 103.43,71.92 103.43,71.92
            100.30,71.92 97.23,70.63 94.98,68.25
            92.73,65.94 91.51,62.68 91.51,59.36
            91.51,52.36 96.89,46.72 103.50,46.72
            103.50,46.72 103.50,46.79 103.50,46.79 Z"
    />
  ),
}
